import {
  PAGESIZE_UPDATED,
  PAGE_SELECTED,
  ASSETS_FAILED_TO_POPULATE,
  ASSETS_SELECTED,
  ASSET_VIEWED
} from './assets.action';

import * as SearchActions from '../search/search.action';
import {INITIAL_STATE} from './assets.state';

export const AssetsReducer = (state = INITIAL_STATE, {type, payload}) => {
  switch (type) {
    case PAGESIZE_UPDATED:
      return {
        ...state,
        pageSize: payload,
        totalPages: Math.ceil(state.totalCount / payload)
      };

    case PAGE_SELECTED:
      return {
        ...state,
        currentPage: payload
      };

    case SearchActions.SEARCH_SUCCESS: {
      const syncListWithSelection = (list = [], selections = []) => {
        const selectedIds = selections.map(asset => asset.id);
        return list.map(asset => ({...asset, selected: selectedIds.includes(asset.id)}));
      };
      const getselections = (list = []) => {
        return list.filter(asset => asset.selected);
      };
      //if search result from 0 will override the list and re-apply the old selected
      // otherwise user gettinmg more result => will add to the list (user scrolling or calling another page)
      const addToList = payload.query.since > 0;
      const list = addToList
        ? [...state.list, ...payload.data.hits]
        : syncListWithSelection([...payload.data.hits], state.selections);
      //then update the selection to remove any invalid selection that not in the list(will remove it if we need to keep selection for different search)
      const selections = getselections(list);
      return {
        ...state,
        totalCount: payload.data.total,
        list: list,
        totalPages: Math.ceil(payload.data.total / state.pageSize),
        selections: selections
      };
    }

    case SearchActions.UPDATE_SEARCH_PREREQUISITES:
      return {
        ...state,
        currentPage: payload.newSearch ? 1 : state.currentPage,
        list: payload.newSearch ? [] : state.list,
        selections: payload.resetSelectedAssets ? [] : state.selections
      };

    case ASSETS_FAILED_TO_POPULATE:
      return {
        ...state,
        list: [],
        message: payload || ''
      };

    case ASSETS_SELECTED:
      return {
        ...state,
        selections: payload
      };

    case ASSET_VIEWED:
      return {
        ...state,
        viewedAssetId: payload.id
      };

    default:
      return state;
  }
};
